import React from "react";
import "./JibuCTA.css";

const JibuCTA = ({ isDarkMode }) => {
  return (
    <section className={`jibu-cta-section ${isDarkMode ? "dark-mode" : "light-mode"}`}>
      <div className="cta-container">
        <h2 className="cta-heading">Supercharge Your Conversations with JibuBot</h2>
        <p className="cta-subtext">
          Start your free trial and let JibuBot handle your customer engagement 24/7 — across all your channels.
        </p>
        <a href="#start-trial" className="cta-button">Start Free Trial</a>
      </div>
    </section>
  );
};

export default JibuCTA;
